import { __assign } from "tslib";
import * as React from 'react';
import { setLocale, zhCN } from './time-locale';
var common = {
    confirm: '确认',
    cancel: '取消',
    ok: '我知道了',
    comma: '，',
    reset: '重置',
};
export var mark = 'zh-CN';
export var CopyButton = {
    copy: '复制',
    success: '复制成功',
    error: '复制失败',
};
export var Pagination = {
    jumpTo: function (_a) {
        var input = _a.input;
        return React.createElement(React.Fragment, null,
            "\u8DF3\u81F3",
            input,
            "\u9875");
    },
    pageStats: function (_a) {
        var total = _a.total, select = _a.select, Text = _a.Text;
        return (React.createElement(React.Fragment, null,
            "\u5171 ",
            React.createElement(Text, { type: "middle" }, total),
            " \u6761\uFF0C\u6BCF\u9875",
            select));
    },
    pageStatsStatic: function (_a) {
        var total = _a.total, pageSize = _a.pageSize, Text = _a.Text;
        return (React.createElement(React.Fragment, null,
            "\u5171 ",
            React.createElement(Text, { type: "middle" }, total),
            " \u6761\uFF0C\u6BCF\u9875",
            React.createElement(Text, { type: "middle" }, pageSize),
            " \u6761"));
    },
    selectWidth: 80,
    items: '条',
};
export var Pop = __assign({}, common);
export var PreviewImage = {
    alt: '图片下载失败',
    prev: '上一张',
    next: '下一张',
    rotate: '翻转',
};
export var RangePicker = {
    7: '近7天',
    30: '近30天',
};
export var Select = {
    input: '请选择',
    empty: '没有找到匹配项',
};
export var Switch = {
    checked: '开启',
    unchecked: '关闭',
};
export var Sweetalert = __assign(__assign({}, common), { title: '提示' });
export var Grid = __assign(__assign({}, common), { emptyLabel: '没有更多数据了' });
export var Table = __assign(__assign({}, common), { emptyLabel: '没有更多数据了' });
export var Cascader = __assign(__assign({}, common), { title: '标题', placeholder: '请选择' });
var QUARTER_NAMES = ['第一季度', '第二季度', '第三季度', '第四季度'];
export var TimePicker = function () {
    setLocale(zhCN);
    return __assign(__assign({}, common), { time: '请选择时间', date: '请选择日期', week: '请选择自然周', month: '请选择月份', quarter: '请选择季度', year: '请选择年', range: '开始日期 至 结束日期', rangeError: '请选择起止时间', start: '开始日期', end: '结束日期', startTime: '开始时间', endTime: '结束时间', to: '至', current: {
            time: '此刻',
            date: '今天',
            week: '本周',
            month: '当前月',
            year: '今年',
        }, panel: {
            hour: '时',
            minute: '分',
            second: '秒',
            hourSelect: '选择小时',
            minuteSelect: '选择分钟',
            secondSelect: '选择秒',
            titleFormat: 'YYYY年MMM',
            quarterNames: QUARTER_NAMES,
            yearQuarterName: function (_a) {
                var year = _a.year, quarter = _a.quarter;
                var val = QUARTER_NAMES[quarter];
                return year + "\u5E74" + val;
            },
            dayNames: ['日', '一', '二', '三', '四', '五', '六'],
            monthNames: [
                '1月',
                '2月',
                '3月',
                '4月',
                '5月',
                '6月',
                '7月',
                '8月',
                '9月',
                '10月',
                '11月',
                '12月',
            ],
        } });
};
export var Upload = __assign(__assign({}, common), { delete: '删除', retry: '重新上传', failed: '上传失败', limit: '文件添加个数已达上限', normal: {
        add: '添加文件',
        tips: function (config) {
            var tips = config.tips, formattedMaxSize = config.formattedMaxSize;
            var tipStr = tips ? tips : '';
            var sizeLimitStr = formattedMaxSize
                ? "\u5355\u4E2A\u6587\u4EF6\u4E0D\u8D85\u8FC7 " + formattedMaxSize
                : '';
            return [tipStr, sizeLimitStr].filter(Boolean).join(common.comma);
        },
    }, image: {
        tips: function (config) {
            var tips = config.tips, formattedMaxSize = config.formattedMaxSize, maxAmount = config.maxAmount;
            var tipStr = tips ? tips : '';
            var amoutLimitStr = maxAmount !== Infinity ? "\u6700\u591A " + maxAmount + " \u5F20" : '';
            var sizeLimitStr = formattedMaxSize
                ? "\u5355\u5F20\u56FE\u7247\u4E0D\u8D85\u8FC7 " + formattedMaxSize
                : '';
            return [tipStr, amoutLimitStr, sizeLimitStr]
                .filter(Boolean)
                .join(common.comma);
        },
    } });
export var Mention = {
    noContent: '无匹配结果，轻敲空格完成输入',
};
